import { Link } from "react-router-dom";

/**
 * Marca do topo das páginas (opção A "Selo da marca", aprovada em 10/14/2026):
 * logo redondo + ENTRE ELAS em letra de inscrição + FÉ • CONEXÃO • PROPÓSITO em rosé, como no logo oficial.
 */
export default function MarcaEntreElas({ className = "" }: { className?: string }) {
  return (
    <Link
      to="/"
      aria-label="Entre Elas — página inicial"
      className={`flex items-center gap-3 whitespace-nowrap text-brown ${className}`}
    >
      <img
        src="/img/logo-entre-elas.jpg"
        alt=""
        className="w-10 h-10 md:w-11 md:h-11 rounded-full shadow-sm shrink-0"
      />
      <span className="flex flex-col leading-none">
        <span className="font-['Cinzel'] text-[15px] md:text-lg tracking-[0.22em]">ENTRE ELAS</span>
        <span className="font-['Montserrat'] font-medium text-[8px] md:text-[9px] tracking-[0.3em] text-[#B9775E] mt-1.5">
          FÉ • CONEXÃO • PROPÓSITO
        </span>
      </span>
    </Link>
  );
}
